import { WorkCenterWeek } from '../Incrementals.types';
import { UiQueries } from './UiQueries';

export function hasUnsavedChangesForWorkCenterWeekQuery(
  this: UiQueries,
  workCenterWeek: WorkCenterWeek
): boolean {
  const hasChanges = workCenterWeek.days.some((day) =>
    day.incrementals.some(
      // eslint-disable-next-line max-nested-callbacks
      (companyIncremental) => companyIncremental.userValue != null
    )
  );

  return hasChanges;
}
